export const NON_APPLICABLE_UOM = '0';
export const DATA_TYPE_UOM_CATEGORIES = [
  'Data - IT',
  'Data - Scientific',
  'Data - Telco'
];
